import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less'],
  templateUrl: './after-subscription-downgrade.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AfterSubscriptionDowngradeTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<AfterSubscriptionDowngradeTemplateData>;
}

export type AfterSubscriptionDowngradeTemplateData = {
  header: string;
  p1_html: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const AfterSubscriptionDowngradeTemplateMocks: AfterSubscriptionDowngradeTemplateData[] = [
  {
    header: 'Job slot limit has been exceeded',
    p1_html:
      "Since you've moved to the Start plan, <b>you now use up to 5 job slots</b>. It looks like you're 3 over the limit. Please reduce it to 5 by archiving jobs before <b>Feb 28th</b>. After that date, we will auto-archive jobs for you.",
    button_text: 'Go to Recruitee',
    button_link: 'http://recruitee.com',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
